export default __webpack_public_path__ + "static/media/client-id-golden.15a42f1f.svg";